<!-- bg-white  -->
<div
  class="tw-group tw-relative tw-rounded-2xl tw-flex-center border tw-px-3 tw-shadow-sm tw-transition-shadow tw-hover:shadow-md"
  [ngClass]="{
    'tw-cursor-pointer': !isReadonly,
    'tw-cursor-not-allowed': isReadonly
  }"
  [class]="
    sizeClass +
    ' ' +
    (active
      ? 'tw-bg-gradient-to-r tw-from-primary-100 tw-to-primary-200  dark:tw-from-primary-600 dark:tw-to-primary-700 dark:tw-text-gray-50 tw-text-primary-500 tw-font-semibold  '
      : ' tw-bg-white dark:tw-bg-dark-100 hover:tw-dark:bg-gray-750 tw-text-gray-600 dark:tw-text-gray-100')
  "
>
  <!-- border-2 border-primary-500 -->
  <ng-content></ng-content>

  @if (active && isShowTick) {
  <span
    class="tw-absolute tw-bg-primary-500 dark:tw-bg-primary-500 tw-rounded-full tw-flex-center"
    [ngClass]="{
      ' tw-top-[-15px]': tickPosition == 'top',
      ' tw-right-[-15px]': tickPosition == 'right',
      ' tw-left-[-15px]': tickPosition == 'left',
      ' tw-w-[35px] tw-h-[35px]': tickSize == 'lg',
      ' tw-w-[30px] tw-h-[30px]': tickSize == 'md',
      ' tw-w-[25px] tw-h-[25px]': tickSize == 'sm'
    }"
    ><i
      class="mdi mdi-check text-white"
      [ngClass]="{
        'mdi-24px': tickSize == 'lg',
        'mdi-22px': tickSize == 'md',
        'mdi-20px': tickSize == 'sm'
      }"
    ></i
  ></span>
  }
</div>
